// 100 Thin (Hairline)
// 200 ExtraLight (UltraLight)
// 300 Light
// 400 Normal (Regular)
// 500 Medium
// 600 SemiBold (DemiBold)
// 700 Bold
// 800 ExtraBold (UltraBold)
// 900 Black (Heavy)

// TODO: Add this font - https://fonts.google.com/specimen/Inter

enum Fonts {
  INTER = 'Inter',
  AVENIR='Avenir-next'
}

export default Fonts
